import React from 'react';
import './Sentence.css';

const Sentence = ({ sentence, triggerWord, content, isOpen, toggleDropdown, onActivate, contentClassName = 'content' }) => {
  const parts = sentence.split(triggerWord);

  const handleClick = () => {
    if (onActivate) {
      onActivate();
      return;
    }
    toggleDropdown();
  };

  return (
    <div
      className={`sentence-container ${isOpen ? 'open' : ''}`}
    >
      <p className="main-sentence" onClick={handleClick}>
        {parts[0]}
        <span className="trigger-word">{triggerWord}</span>
        {parts[1]}
      </p>
      {isOpen && <div className={contentClassName}>{content}</div>}
    </div>
  );
};

export default Sentence;
